export default __webpack_public_path__ + "static/media/mail.507e95b6.svg";